import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { IMyOptions } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.scss']
})
export class ShareComponent implements OnInit {
  public myDatePickerOptions: IMyOptions = {}
  users = [];
  teams = [];
  contacts = [];
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<true>();
  constructor() { }

  ngOnInit() {
  }

  hideMyModal(){
    this.hideModal.emit(true);
  }
}
